import { memoize } from 'lodash-es';

interface Identifiable {
  getId: () => string; // Explicitly expect a string return type
}

export function isJsonLdObject<T>(entity: T): entity is T & { '@id': string } {
  return entity && typeof entity === 'object' && '@id' in entity;
}

export function parseUuidFromIri(iri: string): string {
  const iriRegex: RegExp = new RegExp(/^\/.*\/([A-z\d\-_]*)/);
  const match: string[] | null = iri.match(iriRegex);
  return match ? (match.pop() ?? iri) : iri;
}

export const jsonLdSelectId = memoize(
  (entity: unknown): string => {
    if (typeof entity === 'string') {
      return parseUuidFromIri(entity);
    }

    if (
      entity &&
      typeof entity === 'object' &&
      'getId' in entity &&
      typeof (entity as Identifiable).getId === 'function'
    ) {
      return (entity as Identifiable).getId();
    }

    if (isJsonLdObject(entity)) {
      return parseUuidFromIri(entity['@id']);
    }

    console.error(
      'entity can only be a string or an object with an @id property, Warning this breaking NGRX as a whole',
    );
    throw new Error('entity can only be a string or an object with an @id property');
  },
  (entity: unknown) => {
    if (!entity) {
      return '';
    }
    if (typeof entity === 'string') {
      return entity;
    }

    if (
      typeof entity === 'object' &&
      'getId' in entity &&
      typeof (entity as Identifiable).getId === 'function'
    ) {
      return (entity as Identifiable).getId();
    }

    if (isJsonLdObject(entity)) {
      return entity['@id'];
    }
    return entity;
  },
);
